import {TranscriptionViewerAudioPlayer} from './transcription_viewer_audio_player'

/*
  Displays the view with the call audio in wave surfer and call transcription
  with associated call type keyword matches.
*/
export class CallTypeKeywordTranscriptionViewer extends HTMLElement {
  constructor(hiddenElement, callid, audioSrc, domain_id) {
    super();

    this.callid = callid;
    this.domain_id = domain_id;
    this.hiddenElement = hiddenElement; // the element that was hidden to show this.
    this.audioSrc = audioSrc;
  }

  async connectedCallback() {
    this.innerHTML = `
      <div class='row'>
        <div id='transcription-viewer'>
          <div>
            <h3 class='title' style="float:left; margin-bottom:0px; font-size:18px;"><span id="location-back"></span>View Call Transcription with domain specific keywords.
            </h3>
          </div>
          <hr/>

          <transcription-viewer-audio-player
            src="${this.audioSrc}"
          />
          </transcription-viewer-audio-player>
          
          <div class='row' id='data-container'>
            <div class='col-md-9' id='transcription-container'>
              <legend class='heading'>Transcript</legend>
              <div id='transcription-text'>
                <h3>Loading transcript...</h3>
              </div>
            </div>

            <div class='col-md-3' id='keyword-container'>
              <legend class='heading'>Keywords</legend>
              <div id='transcription-keywords'>
                <h3>Loading keywords...</h3>
              </div>
            </div>

          </div>
        </div>
      </div>
    `;

    this.querySelector('#location-back').addEventListener('click', this.cancelEdit.bind(this));

    await this.loadTranscript();
  }

  using_https() {return ('https:' == document.location.protocol);}

  async loadTranscript() {
    try {
      let res = await fetch(`/transcript/${this.callid}/call_type_keywords?domain_id=${this.domain_id}`);
      let data = await res.json();
      // console.log("transcript: " + JSON.stringify(data.transcript))
      // console.log("keywords: " + JSON.stringify(data.keywords))
      if (data.error) {
        alert("Unable to find transcript. Error: " + data.error)
      }
      else {
        this.renderTranscript(data.transcript)
        this.renderKeywords(data.keywords)
      }
    }
    catch(err) {
      console.log("[loadTranscript] Failed: " + err)
    }  
  }

  renderTranscript(transcript){
    const container = this.querySelector('#transcription-text');
    if (container){
      container.innerHTML = "";
      container.appendChild(new TranscriptionContent2(transcript))
    }
  }
  
  renderKeywords(keywords){
    const container = this.querySelector('#transcription-keywords');
    if (container){
      container.innerHTML = "";
      container.appendChild(new KeywordContent2(keywords))
    }
  }

  cancelEdit(e) {
    e.preventDefault();
    this.remove();
    this.hiddenElement.classList.remove('hidden');
  }

  disconnectedCallback() {
  }
}

customElements.define("call-type-keyword-transcription-viewer", CallTypeKeywordTranscriptionViewer);




class TranscriptionContent2 extends HTMLElement {
  constructor(data) {
    super();
    this.data = data;
  }

  connectedCallback() {
    this.innerHTML = ""
    
    if (this.data && this.data.length > 0) {
      this.data.forEach(element => {
        this.appendChild(new TranscriptionSentence2(element))
      })
    }
    else {
      this.innerHTML = `
        <div class='sentence-container'>
          <h4 class="no-data">No transcript data</h4>
        </div>
        `
    }

  }
}
customElements.define("transcription-content2", TranscriptionContent2);


function momentDurationToTime(dur) {
  var hours = Math.floor(dur.asHours());
  var mins  = Math.floor(dur.asMinutes()) - hours * 60;
  var sec   = Math.floor(dur.asSeconds()) - hours * 60 * 60 - mins * 60;

  return ((hours > 9) ? hours : ("0"+hours)) + ":" + ((mins > 9) ? mins : ("0"+mins)) + ":" + ((sec > 9) ? sec : ("0"+sec));
}

class TranscriptionSentence2 extends HTMLElement {
  constructor(data) {
    super();
    this.data = data;
    this.original_sentence = this.data.sentence;
    this.handleAudioPlayerTimeUpdate = this.handleAudioPlayerTimeUpdate.bind(this);
  }

  handleAudioPlayerTimeUpdate(e){
    this.data.sentence = this.original_sentence.toLowerCase();

    if (this.isWithinCurrentTime(e.detail.currentTime)) {
      this.classList.add('currentSentence');
      this.scrollIntoView({behavior: 'smooth', block:
      'center'});  

      if (document.querySelector('keyword-content2').keyword_active === true) {
        const current_keyword = document.querySelector('keyword-element2.current .keyword-label')
        const current_keyword_text = current_keyword.innerText.trim().toLowerCase();
        var keyword_index = this.data.sentence.indexOf(current_keyword_text);
        if (current_keyword && keyword_index !== -1){
          const highlighted_keyword_text = `<span class="current_keyword">${current_keyword_text}</span>`
  
          // Replace the keyword with <span>keyword</span>
          this.data.sentence = this.data.sentence.replaceAll(current_keyword_text, highlighted_keyword_text);
          document.querySelector('keyword-content2').keyword_active = false;
        }  
      }
      else {
        const current_keyword = document.querySelector('keyword-element2.current');
        if (current_keyword){
          current_keyword.classList.remove('current');
        }
      }
    }
    else {
      this.classList.remove('currentSentence');
    }
    this.render();
  }

  disconnectedCallback() {
    document.removeEventListener("audioPlayerTimeUpdate", this.handleAudioPlayerTimeUpdate);
  }


  render() {
    const formatted_start_time = momentDurationToTime(moment.duration(this.data.start_time, "seconds"));
    const formatted_end_time = momentDurationToTime(moment.duration(this.data.end_time, "seconds"));
    this.innerHTML = `
      <div class='sentence-container ${this.data.speaker.toLowerCase()}'>
        <p class="sentence-label">
          ${this.data.speaker} - (${formatted_start_time} - ${formatted_end_time})
        </p>
        <span class="sentence">${this.data.sentence}</span>
      </div>
    `  
  }
  
  connectedCallback() {
    this.render();

    document.addEventListener("audioPlayerTimeUpdate", this.handleAudioPlayerTimeUpdate);

    this.addEventListener("click", (e)=>{
      this.dispatchTimeUpdateEvent()
    })
  }

  dispatchTimeUpdateEvent(){
    this.dispatchEvent(new CustomEvent('newSeekTimeForAudioPlayer', 
      {bubbles: true, detail: {newTime: this.data.start_time}}
    ))  
  }


  isWithinCurrentTime(currentTime) {
    return this.data.start_time <= currentTime && this.data.end_time >= currentTime;
  }
}
customElements.define("transcription-sentence2", TranscriptionSentence2);


class KeywordContent2 extends HTMLElement {
  constructor(data) {
    super();
    this.data = data;
  }

  connectedCallback() {
    this.innerHTML = ""

    if (this.data){
      // Create the menu based on the call_types.call_type.name values
      const call_types = Object.keys(this.data);
      const menu = document.createElement('select');
      menu.setAttribute('id','call_type_menu');
      menu.classList.add('form-control');
      menu.onclick = this.callTypeMenuChanged.bind(this);
      this.data.call_types.forEach(call_type => {
        call_type = call_type["call_type"];
        const option = document.createElement('option');
        option.innerText = `Call Type: ${call_type.name}`;
        option.setAttribute('value',call_type.name);
        menu.appendChild(option);
      })
      this.appendChild(menu);

      this.displaySelectedCallTypeKeywords();
    }
    else {
      this.innerHTML = `
        <div class='keyword-container'>
          <h4 class="no-data">No keyword data</h4>
        </div>
        `
    }  
  }
  
  callTypeMenuChanged(e){
    const v = e.currentTarget.value;
    this.displaySelectedCallTypeKeywords(v);
  }

  displaySelectedCallTypeKeywords(callTypeName){
    // render call types of the selected call type

    // callTypeName is undefined, selected the first menu item
    if (typeof callTypeName === 'undefined'){
      callTypeName = this.querySelector('#call_type_menu:first-child').value;
    }

    // Find the matching keywords for the selected call type.
    const matchingCallTypeData = this.data.call_types.find(call_type => {
      return call_type.call_type.name === callTypeName;
    });
    this.buildCallTypeKeywordElements(matchingCallTypeData.call_type.keywords);
  }

  buildCallTypeKeywordElements(keywords){
    this.querySelectorAll('keyword-element2').forEach(el => el.remove());
    keywords.forEach(keywordEl => {
      this.appendChild(new KeywordElement2(keywordEl.keyword, keywordEl.matches))
    })
  }
}
customElements.define("keyword-content2", KeywordContent2);

// This is the displayable keyword data.
// If there are multiple matches of a keyword, show pull down menu.
class KeywordElement2 extends HTMLElement {
  constructor(keyword, keyword_matches) {
    super();
    this.keyword = keyword.toLowerCase();
    this.keyword_matches = keyword_matches;
  }

  connectedCallback() {
    this.innerHTML = `
      <div class='keyword-container'>
        <p>
          <span class="keyword-label">
            <strong>
              ${this.keyword}
            </strong>
          </span> - 
          <span>
            (${this.keyword_matches.length})
          </span>
        </p>
        <div class='keyword-matches'></div>
      </div>
    `

    this.renderKeywordHtml();
  }

  renderKeywordHtml() {
    const container = this.querySelector('.keyword-matches');
    if (! container) return;

    
    if (this.keyword_matches.length === 1) {
      this.createClickableTimeRange(this.keyword_matches[0], this.keyword, container);
    }
    else if (this.keyword_matches.length > 1) {
      const menu = document.createElement('select');
      menu.classList.add('keyword-select-menu')
      this.keyword_matches.forEach(match => {
        const formatted_start_time = momentDurationToTime(moment.duration(match.start_time, "seconds"));
        const formatted_end_time = momentDurationToTime(moment.duration(match.end_time, "seconds"));
        const time_range = `${formatted_start_time} - ${formatted_end_time}`
        const option = document.createElement('option');
        option.setAttribute('value', match.start_time)
        option.setAttribute('data-start-time', match.start_time);
        option.setAttribute('data-end-time', match.end_time);
        option.setAttribute('data-keyword', this.keyword);
        option.innerText = time_range;
        menu.appendChild(option);
      })

      container.appendChild(menu)

      menu.addEventListener('change',(e)=>{
        const option = e.currentTarget.options[e.currentTarget.selectedIndex]
        const start_time = Number(option.getAttribute('data-start-time'))
        const end_time = Number(option.getAttribute('data-end-time'))
        const keyword = option.getAttribute('data-keyword')
        const time_range = {"start_time": start_time, "end_time":end_time};
        const container = this.querySelector('.keyword-matches');
        this.createClickableTimeRange(time_range, keyword, container);
        this.dispatchTimeUpdateEvent(start_time, end_time, keyword);
      })

      // create the clickable time range for the first element
      this.createClickableTimeRange(this.keyword_matches[0], this.keyword, container);
    }
  }
  
  createClickableTimeRange(time_range, keyword, container){
    const clickable_keyword_container = this.querySelector('.clickable-keyword-container');
    if (clickable_keyword_container){
      clickable_keyword_container.remove()
    }

    const div = document.createElement('div');
    div.classList.add('clickable-keyword-container')
    const link = document.createElement('a');
    link.classList.add('clickable-keyword')
    link.setAttribute('title', 'Click to go to this keyword');
    link.setAttribute('data-start-time', time_range.start_time);
    link.setAttribute('data-end-time', time_range.end_time);

    const formatted_start_time = momentDurationToTime(moment.duration(time_range.start_time, "seconds"));
    const formatted_end_time = momentDurationToTime(moment.duration(time_range.end_time, "seconds"));
    link.innerText = `${formatted_start_time} - ${formatted_end_time}`
    div.appendChild(link);
    container.appendChild(div);

    link.addEventListener('click', (e)=>{
      e.preventDefault();
      const start_time = time_range.start_time;
      const end_time = time_range.end_time;
      this.dispatchTimeUpdateEvent(start_time, end_time, keyword);
    })
  }
  
  dispatchTimeUpdateEvent(start_time, end_time, keyword){
    const currentKeyword = document.querySelector('keyword-element2.current');
    if (currentKeyword && currentKeyword !== this) {
      currentKeyword.classList.remove('current')
    }
    if (!this.classList.contains('current')) {
      this.classList.add('current')
      document.querySelector('keyword-content2').keyword_active = true;
    }
    else {
      document.querySelector('keyword-content2').keyword_active = true;
    }
    
    this.dispatchEvent(new CustomEvent('newSeekTimeForAudioPlayer', 
      {bubbles: true, detail: {startTime: start_time, endTime: end_time, keyword: keyword}}
    ))  
  }

}
customElements.define("keyword-element2", KeywordElement2);
